import { render, staticRenderFns } from "./deliverytime.vue?vue&type=template&id=6929d97a&"
import script from "./deliverytime.vue?vue&type=script&lang=js&"
export * from "./deliverytime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports